import { createHandlerChainRunner, Handler, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import setShippingMethod from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/SetShippingMethod";
import {
    AddCollectAccountApiParameter,
    AddCollectAccountApiResult,
    CarrierDto,
} from "@insite/client-framework/Types/ApiModels";
import { addNewCollectAccount } from "@sonic/Services/CollectAccountService";

type HandlerType = Handler<
    {
        carrier: CarrierDto;
        newCollectAccount: string;
        isDefault: boolean;
    } & HasOnSuccess<string> &
        HasOnError<string>,
    {
        apiParameter: AddCollectAccountApiParameter;
        apiResult: AddCollectAccountApiResult;
        apiCallHasError: boolean;
    }
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        CarrierId: props.parameter.carrier?.id ?? "",
        CollectAccount: props.parameter.newCollectAccount,
        IsDefault: props.parameter.isDefault,
    };
    props.apiCallHasError = false;
};
export const CallApi: HandlerType = async props => {
    try {
        props.apiResult = await addNewCollectAccount(props.apiParameter);
    } catch {
        props.apiCallHasError = true;
    }
};
export const OnError: HandlerType = props => {
    if ((props.apiCallHasError || !props.apiResult.isSuccessful) && props.parameter.onError) {
        props.parameter.onError(props.apiResult?.resultMessage);
        return false;
    }
};
export const OnSuccess: HandlerType = props => {
    if (props.parameter.onSuccess) {
        props.parameter.onSuccess(props.apiResult?.resultMessage);
    }
};

export const chain = [PopulateApiParameter, CallApi, OnError, OnSuccess];

const addCollectAccount = createHandlerChainRunner(chain, "AddCollectAccount");
export default addCollectAccount;
